// src/routes/auth.routes.js
import { Suspense, lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthLayout from '../layouts/authLayout';

// Lazy load auth pages
const AdminLogin = lazy(() => import('../pages/admin/adminLogin'));
// const SuperAdminSignup = lazy(() => import('../pages/admin/superAdminSignup'));

const authRoutes = {
  path: 'auth',
  element: (
    <AuthLayout>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </AuthLayout>
  ),
  children: [
    {
      path: '',
      element: <Navigate to="login" replace />
    },
    {
      path: 'login',
      element: <AdminLogin />
    },
    // {
    //   path: 'super-admin-signup',
    //   element: <SuperAdminSignup />
    // }
  ]
};

export default authRoutes;